/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';
import styles from './index.styl';

const ControlsItem = ({ children, className, fixed, style }) => (
  <div
    {...{ children, className, style }}
    styleName={classNames('controls--item', {
      'controls--item--fixed': fixed,
    })}
  />
);

ControlsItem.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node,
    PropTypes.number,
    PropTypes.string,
  ]),
  className: PropTypes.string,
  fixed: PropTypes.bool,
  style: PropTypes.object,
};

export default CSSModules(ControlsItem, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/ContentArea/ControlsItem.jsx